export default {
  zh: {
    downloadTemplate: '模板下载',
    selectObject: '选择类型',
    selectFile: '选择文件',
    select: '选择',
    import: '导入',
    importHistory: '导入历史',
    exportTemplate: '导出模板',
    selectFields: '选择字段',
    download: '下载',
    importRequestId: '导入请求号',
    objectType: '类型',
    importDate: '导入日期',
    information: '信息',
    importedBy: '导入者',
    status: '状态',
  },
  en: {
    downloadTemplate: 'Download Template',
    selectObject: 'Select Object',
    selectFile: 'Select File',
    select: 'Select',
    import: 'Import',
    importHistory: 'Import History',
    exportTemplate: 'Export Template',
    selectFields: 'Select Fields',
    download: 'Download',
    importRequestId: 'Import Request ID',
    objectType: 'Object Type',
    importDate: 'Import Date',
    information: 'Infomation',
    importedBy: 'Imported By',
    status: 'Status',
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/i18n.js